/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';

/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color} 

Start styles for component here
Your Styles goes here  
End styles for component here

Styles overrides - Do not Remove This Code Block
Data feed styles overrides goes here

*/
const CpdsImageStyleTag = styled.img`
  ${({
    theme: {
      styles: { cpds },
    },
  }) => css`
    ${(props) => props?.styles}
    ${(props) => props?.styleOverrides}
  `}
`;

const CpdsImagWrapper = styled.div.attrs(() => ({ className: 'cpds-image-wrapper' }))`
  &.cpds-image-wrapper {
    position: relative;
    ::before {
      content: '';
      z-index: 10;
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 100%);
      ${(props) => props?.styles}
    }
  }
`;

export { CpdsImageStyleTag, CpdsImagWrapper };
